module.exports = __webpack_public_path__ + "img/copy.7b74311c.png";